import React, { memo, useCallback, useContext, MouseEvent } from 'react'
import { HorizontalDotsMinor } from '@shopify/polaris-icons'
import { Button } from 'src/components/shared/Button'
import { TeamMember } from 'src/interfaces/team'
import { TeamMembersTableContext } from './TeamMembersTable.context'

interface Props {
  teamMember: TeamMember
}

const TeamMemberActionButtonComponent = ({ teamMember }: Props) => {
  const { openTeamMemberItemAction } = useContext(TeamMembersTableContext)

  const handleClickAction = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation()
      openTeamMemberItemAction(event, teamMember)
    },
    [teamMember],
  )

  return (
    <Button
      color="white"
      size="tiny"
      leftIcon={<HorizontalDotsMinor width={20} height={20} />}
      onClick={handleClickAction}
      data-testid={`my-team-members-row-${teamMember.id}-actions-btn`}
    />
  )
}

export const TeamMemberActionButton = memo(TeamMemberActionButtonComponent)
